/* === Cannoli Box PDP — gifting redesign JS (2026-05-19) === */
(function () {
  'use strict';

  var state = { qty: 2, price: 0, cards: {} };
  var L = window.cbPdpbLabels || {
    inCart: 'Kies je bundel', adding: 'Toevoegen…', added: '✓ Toegevoegd',
    box: ' box · ', boxen: ' boxen · ', chosen: ' gekozen'
  };

  function fmtEUR(cents) {
    var n = (cents / 100).toFixed(2).replace('.', ',');
    var cur = ((window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || window.cbPdpbCur || 'EUR').toUpperCase();
    if (cur === 'SEK' || cur === 'DKK' || cur === 'NOK') return n + ' kr';
    return '€' + n;
  }

  function updateCta() {
    var label = document.querySelector('[data-pdpb-cta-label]');
    if (!label) return;
    var total = state.price;
    Object.keys(state.cards).forEach(function (k) { total += (state.cards[k] || 0) * 95; });
    label.textContent = L.inCart + ' · ' + fmtEUR(total);
    var stickyBtn = document.querySelector('[data-pdpb-sticky-btn]');
    if (stickyBtn) stickyBtn.textContent = state.qty + (state.qty === 1 ? L.box : L.boxen) + fmtEUR(total);
  }

  function bindThumbs() {
    var thumbs = document.querySelectorAll('[data-pdpb-thumb]');
    var main = document.getElementById('pdpb-main-img');
    var slider = document.querySelector('[data-pdpb-swipe]');
    thumbs.forEach(function (t, idx) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-pdpb-thumb');
        if (main && src) main.src = src;
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        // Also scroll mobile swipe slider to this index
        if (slider) {
          slider.scrollTo({ left: idx * slider.clientWidth, behavior: 'smooth' });
        }
      });
    });
  }

  function bindBundles() {
    var opts = document.querySelectorAll('[data-pdpb-qty]');
    var bundleWrap = document.querySelector('.pdpb-bundles--v2');
    opts.forEach(function (o) {
      o.addEventListener('click', function () {
        opts.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-checked', 'false'); });
        o.classList.add('is-active');
        o.setAttribute('aria-checked', 'true');
        state.qty = parseInt(o.getAttribute('data-pdpb-qty'), 10) || 1;
        state.price = parseInt(o.getAttribute('data-price'), 10) || 0;
        updateCta();
        // Stop puls-animatie op Meest gekozen badge zodra gebruiker een keuze maakt
        if (bundleWrap) bundleWrap.classList.add('is-interacted');
      });
      if (o.classList.contains('is-active')) {
        state.qty = parseInt(o.getAttribute('data-pdpb-qty'), 10) || 1;
        state.price = parseInt(o.getAttribute('data-price'), 10) || 0;
      }
    });
    updateCta();
  }

  function updateAddonsCount() {
    var el = document.querySelector('[data-pdpb-addons-count]');
    if (!el) return;
    var total = 0;
    Object.keys(state.cards).forEach(function (k) { total += state.cards[k] || 0; });
    if (total > 0) {
      el.style.display = 'inline';
      el.textContent = '· ' + total + L.chosen;
    } else {
      el.style.display = 'none';
    }
  }

  function bindCards() {
    var picks = document.querySelectorAll('[data-pdpb-card]');
    picks.forEach(function (pick) {
      var id = pick.getAttribute('data-pdpb-card');
      var countEl = pick.querySelector('[data-pdpb-card-count]');
      var deltas = pick.querySelectorAll('[data-pdpb-card-delta]');
      deltas.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var d = parseInt(btn.getAttribute('data-pdpb-card-delta'), 10) || 0;
          var cur = state.cards[id] || 0;
          var nu = Math.max(0, cur + d);
          state.cards[id] = nu;
          if (countEl) countEl.textContent = nu;
          pick.classList.toggle('is-on', nu > 0);
          updateAddonsCount();
          updateCta();
        });
      });
    });
  }

  function bindCountdown() {
    var els = document.querySelectorAll('[data-pdpb-countdown]');
    if (!els.length) return;
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var now = new Date();
      var target = new Date();
      target.setHours(23, 0, 0, 0);
      if (target - now < 0) target.setDate(target.getDate() + 1);
      var diff = Math.max(0, target - now);
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var txt = pad(h) + ':' + pad(m) + ':' + pad(s);
      els.forEach(function (el) { el.textContent = txt; });
    }
    tick();
    setInterval(tick, 1000);
  }

  // Open the cart drawer right away (optimistic) so the click feels instant.
  // Without this the drawer only opened after /cart/add.js returned (~400ms+ on
  // mobile), which felt like \"nothing happens / drawer doesn't open\". Contents are
  // filled in by the cart:refresh / section re-render once the add completes.
  function openDrawerNow(trigger) {
    if (typeof window.cbOpenCartDrawer === 'function') {
      window.cbOpenCartDrawer(trigger);
      return;
    }
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    if (typeof d.open === 'function') d.open(trigger || document.body);
    else { d.classList.add('animate', 'active'); document.body.classList.add('overflow-hidden'); }
  }

  function bindBuy() {
    var btn = document.querySelector('[data-pdpb-buy]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var variantId = btn.getAttribute('data-pdpb-variant');
      if (!variantId) return;
      var wantQty = state.qty;
      btn.disabled = true;
      var lbl = btn.querySelector('[data-pdpb-cta-label]');
      var original = lbl ? lbl.textContent : btn.textContent;
      if (lbl) lbl.textContent = L.adding;
      // Open the drawer immediately — don't wait for the network round-trip.
      openDrawerNow(btn);
      // Use the canonical /cart/add.js shape (id + quantity at root) — items[] form has shown odd quantity behavior in some stacks
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: wantQty })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          // Verify cart actually has the requested quantity for this variant; if Shopify split or capped it, fix via /cart/change.js
          return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
            var lineIdx = -1, current = 0;
            cart.items.forEach(function (it, idx) {
              if (String(it.variant_id) === String(variantId)) { lineIdx = idx; current = it.quantity; }
            });
            if (lineIdx >= 0 && current !== wantQty) {
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ line: lineIdx + 1, quantity: wantQty })
              });
            }
          });
        })
        .then(function () {
          var cardIds = Object.keys(state.cards).filter(function (c) { return (state.cards[c] || 0) > 0; });
          return cardIds.reduce(function (chain, cid) {
            return chain.then(function () {
              return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: cid, quantity: state.cards[cid] }) });
            });
          }, Promise.resolve());
        })
        .then(function () {
          if (lbl) lbl.textContent = L.added;
          document.dispatchEvent(new CustomEvent('cb:cart-updated'));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(function () {
            // Drawer is already open; ensure it is (in case it was closed) and reset the button.
            openDrawerNow(btn);
            btn.disabled = false;
            if (lbl) lbl.textContent = original;
          }, 300);
        })
        .catch(function () {
          if (lbl) lbl.textContent = original;
          btn.disabled = false;
        });
    });
  }

  function bindSwipe() {
    var slider = document.querySelector('[data-pdpb-swipe]');
    var dotsWrap = document.querySelector('[data-pdpb-swipe-dots]');
    if (!slider) return;
    var dots = dotsWrap ? dotsWrap.querySelectorAll('.pdpb-swipe__dot') : [];
    var slides = slider.querySelectorAll('.pdpb-swipe__slide');
    if (!slides.length) return;
    var allThumbs = document.querySelectorAll('[data-pdpb-thumb]');
    function setActive(idx) {
      dots.forEach(function (d, i) {
        if (i === idx) d.classList.add('is-active'); else d.classList.remove('is-active');
      });
      // Sync thumb strip active state (mobile) — also scroll thumb into view
      allThumbs.forEach(function (t, i) {
        if (i === idx) { t.classList.add('is-active'); t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); }
        else t.classList.remove('is-active');
      });
    }
    slider.addEventListener('scroll', function () {
      var idx = Math.round(slider.scrollLeft / slider.clientWidth);
      setActive(idx);
    }, { passive: true });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        slider.scrollTo({ left: i * slider.clientWidth, behavior: 'smooth' });
      });
    });
  }

  function fixBundleCurrency() {
    var cur = (window.cbPdpbCur || 'EUR').toUpperCase();
    if (cur !== 'SEK' && cur !== 'DKK' && cur !== 'NOK') return;
    document.querySelectorAll('.pdpb-bopt__price .p, .pdpb-bopt__price .s, .pdpb-bopt__save').forEach(function(el){
      el.textContent = el.textContent.replace(/€\s*([\d.]+,\d{2})/g, '$1 kr');
    });
  }
  function init() {
    fixBundleCurrency();
    bindThumbs();
    bindBundles();
    bindCards();
    bindCountdown();
    bindBuy();
    bindSwipe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();